// Webpack stub for Node-only modules referenced by fflate (browser bundle)
module.exports = {}



//////////////////
// WEBPACK FOOTER
// ./build/empty-module.js
// module id = mBkJ
// module chunks = 1